
export class EMailInboxFile {

id: string;

userId: string;

type: string;

fromId: string;

toId: string;

fromText: string;

replyText: string;

toText: string;

subject: string;

message: string;

dateSent: string;

dateSeen: string;

}